const theme = {
 primary_bg_color     : '#FFFFFF',
 secondary_bg_color   : '#fafafa',
 third_bg_color       : '#f5f5f5',
 primary_text_color   : '#e5252c',
 secondary_color      : '#e5252c',
 loader_color         : '#e5252c'
};

export default theme;